var tabs = {
  init: function () {
    document.querySelectorAll(".tabs").forEach(function (tabsContainer) {
      const tabButtons = tabsContainer.querySelectorAll(".tabs__tab");
      const tabPanels = tabsContainer.querySelectorAll(".tabs__panel");

      tabButtons.forEach(function (btn, idx) {
        btn.addEventListener("click", function () {
          // Deaktivace všech tabů a panelů
          tabButtons.forEach(function (b) {
            b.classList.remove("tabs__tab--active");
            b.setAttribute("aria-selected", "false");
          });
          tabPanels.forEach(function (panel) {
            panel.classList.remove("tabs__panel--active");
            panel.setAttribute("hidden", "");
          });
          // Aktivace vybraného tabu a panelu
          btn.classList.add("tabs__tab--active");
          btn.setAttribute("aria-selected", "true");
          const panelId = btn.getAttribute("aria-controls");
          const panel = tabsContainer.querySelector("#" + panelId);
          if (panel) {
            panel.classList.add("tabs__panel--active");
            panel.removeAttribute("hidden");
          }
        });
      });
    });
  },
};

export { tabs };
